import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../common/Navigation/Navigation';
import Loader from '../common/Loader/Loader';
import ScrollToTop from '../common/ScrollToTop/ScrollToTop';
import { applyTelegramTheme } from '../../utils/themeUtils';
import { shouldUseFullscreen, getDeviceType } from '../../utils/deviceUtils';
import { useTelegram } from '../../hooks/useTelegram';
import './MainLayout.css';

const MainLayout = () => {
  const [loading, setLoading] = useState(true);
  const { isFullscreen } = useTelegram();

  useEffect(() => {
    // Expand the web app to take full height only for mobile devices
    if (window.Telegram?.WebApp && shouldUseFullscreen()) {
      const webApp = window.Telegram.WebApp;
      const deviceType = getDeviceType();
      
      console.log(`📱 Device type: ${deviceType}, expanding WebApp for mobile device`);
      
      if (!webApp.isExpanded && deviceType === 'mobile') {
        webApp.expand();
      }
    } else {
      console.log(`💻 Device type: ${getDeviceType()}, skipping WebApp expansion for non-mobile device`);
    }
    
    // Apply theme based on Telegram's theme parameters
    if (window.Telegram?.WebApp?.themeParams) {
      applyTelegramTheme(window.Telegram.WebApp.themeParams);
    } else if (window.Telegram?.WebApp?.colorScheme) {
      // Fallback to just using the color scheme class
      document.documentElement.classList.add(`theme-${window.Telegram.WebApp.colorScheme}`);
    }
    
    // Simulate loading time (you can remove this in production)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader splash={true} />;
  }

  // Определяем нужно ли добавлять класс для полноэкранного режима
  const contentClasses = `content ${shouldUseFullscreen() && isFullscreen ? 'fullscreen-mode' : ''}`.trim();

  return (
    <>
      <ScrollToTop />
      <div className={contentClasses}>
        <Outlet />
      </div>
      <Navigation />
    </>
  );
};

export default MainLayout; 